import script from "./deleteButton.vue?vue&type=script&setup=true&lang=js"
export * from "./deleteButton.vue?vue&type=script&setup=true&lang=js"

import "./deleteButton.vue?vue&type=style&index=0&id=be2d8676&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be2d8676"]])

export default __exports__